import React, { useEffect, useState } from "react";
import LoadingGif from "@public/img/loading.gif";
import { Link } from "react-router-dom";
import { Pagination } from "@/lib/api";
import PaginationView from "@/component/commom/pagination";
import { TicketData } from "@/entry/server/app";
import { appRepo } from "@/repo/app-repo";
import TicketSlashIcon from "@public/img/ticket-slash.svg";
import EyeIcon from "@public/img/eye.svg";
import { useTicketsRedirect } from "./use-tickets-redirect";

export default function Page() {
    var ticketsEnabled = useTicketsRedirect();
    const [tickets, setTickets] = useState<TicketData[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [pagination, setPagination] = useState<Pagination | undefined>(undefined);
    const [page, setPage] = useState<number>(1);

    useEffect(function () {
        if (!ticketsEnabled) {
            return;
        }
        appRepo.getTickets(page).then((res) => {
            setTickets(res.data ?? []);
            setPagination(res.pagination ?? undefined);
            setLoading(false);
        });
    }, [page, ticketsEnabled]);

    if (!ticketsEnabled) {
        return null;
    }

    return (
        <div className="w-full lg:min-h-[560px] rounded-xl bg-bg2 p-4 flex flex-col gap-4">
            <div className="w-full flex items-center justify-between">
                <h2 className="text-2xl font-bold text-white">تیکت‌های من</h2>
                <Link to="/profile/tickets/create" className="border border-lime-400 text-lime-400 px-3 py-2.5 rounded-lg cursor-pointer flex items-center gap-2">
                    <span>تیکت جدید</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M12 5V19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M5 12H19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </Link>
            </div>

            <div className={`w-full flex-1 flex flex-col gap-4 ${loading || tickets.length === 0 ? 'justify-center items-center' : ''}`}>
                {loading && <img src={LoadingGif} alt="loading" />}

                {!loading && tickets.length === 0 && (
                    <>
                        <img src={TicketSlashIcon} alt="Ticket Splash" className="text-lime-400" />
                        <p className="text-2xl font-bold text-white"><span className="text-lime-400">تیکتی</span> وجود ندارد</p>
                        <p className="text-zinc-400">
                            هیچ تیکتی وجود ندارد. برای ایجاد تیکت جدید &nbsp;
                            <Link to="/profile/tickets/create" className="text-lime-400 hover:underline">اینجا</Link>
                            &nbsp;کلیک کنید.
                        </p>
                    </>
                )}

                {!loading && tickets.length > 0 && (
                    <div className="w-full max-w-full overflow-x-auto">
                        <table className="w-full border-separate border-spacing-y-2 max-w-full overflow-x-auto">
                            <thead>
                                <tr>
                                    <th className="text-sm font-bold text-center">شناسه</th>
                                    <th className="text-sm font-bold text-center">موضوع</th>
                                    <th className="text-sm font-bold text-center hidden sm:block">آخرین بروزرسانی</th>
                                    <th className="text-sm font-bold text-center">وضعیت</th>
                                    <th className="text-sm font-bold text-center"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {tickets.map((ticket) => (
                                    <tr key={ticket.id} className="text-center">
                                        <td className="border-y border-r border-zinc-700 rounded-r-xl px-3 py-2">{ticket.id}</td>
                                        <td className="border-y border-zinc-700 px-3 py-2"><span className="line-clamp-1">{ticket.title}</span></td>
                                        <td className="border-y border-zinc-700 px-3 py-2 ltr hidden sm:table-cell">{ticket.updated_at}</td>
                                        <td className="border-y border-zinc-700 px-3 py-2">
                                            <span className={`text-sm text-zinc-100 rounded-full py-0.5 px-2.5 w-fit ${ticket.status === "answered" ? "bg-sky-600" : ticket.status === "closed" ? "bg-emerald-600" : "bg-red-600"}`} style={{ textWrap: "nowrap" }}>
                                                {ticket.status === "answered" ? "پاسخ داده شده" : ticket.status === "closed" ? "بسته شده" : "درحال بررسی"}
                                            </span>
                                        </td>
                                        <td className="border-y border-l border-zinc-700 rounded-l-xl px-3 py-2 flex justify-center">
                                            <Link to={`/profile/tickets/${ticket.id}`} className="text-sm text-zinc-100 border border-zinc-500 py-2.5 px-3 rounded-lg flex items-center justify-center gap-2 hover:bg-zinc-500 hover:text-zinc-900 transition-all duration-300 w-fit">
                                                <span>مشاهده</span>
                                                <img src={EyeIcon} alt="Eye" />
                                            </Link>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {pagination && <PaginationView pagination={pagination} black={true} onChange={setPage} />}
        </div>
    );
}